import React, { useEffect, useState } from "react";
import { Outlet } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import { SET_DELIVERY_DATA } from "store/delivery/actions"

import { httpOk, GET } from 'helpers/api'

function Layout() {
	const dispatch = useDispatch()

	const reduxAccount = useSelector(state => state.account)
	const reduxDelivery = useSelector(state => state.delivery)

	const [isReady, setIsReady] = useState(false);

	async function getData() {
		try {
			let poses = reduxDelivery?.poses || [];
			let comments = reduxDelivery?.comments || [];
			let paymentTypes = reduxAccount?.call_center?.payment_types || [];
			let externalCouriers = reduxDelivery?.externalCouriers || [];
			let externalMenu = reduxDelivery?.externalMenu || [];
			let autoAddRules = reduxDelivery?.autoAddRules || [];
			let menuData = reduxDelivery?.menu || [];
			let products = reduxDelivery?.products || [];

			// Подгружаем только то, чего нет в redux
			if (!reduxDelivery?.poses?.length) {
				const response = await GET("/helper/poses");
				poses = response.data;
			}

			if (!reduxDelivery?.poses?.length) {
				const response = await GET("/delivery/auto-add-rules");
				if (httpOk(response)) autoAddRules = response.data;
			}

			if (!reduxDelivery?.menu?.length) {
				const response = await GET("/delivery/menu");
				if (httpOk(response)) menuData = response.data.menu;
				if (httpOk(response)) products = response.data.products;
			}

			if (!reduxDelivery?.externalMenu?.length) {
				const response = await GET("/delivery/external-menu");
				if (httpOk(response)) externalMenu = response.data;
			}

			if (!reduxDelivery?.comments?.length) {
				const response = await GET("/helper/comments");
				if (httpOk(response)) comments = response.data;
			}

			if (!reduxDelivery?.externalCouriers?.length) {
				const response = await GET("/helper/external-couriers");
				if (httpOk(response)) externalCouriers = response.data;
			}

			// Обновляем redux
			dispatch(
				SET_DELIVERY_DATA({
					poses,
					menu: menuData,
					products,
					comments,
					paymentTypes,
					externalCouriers,
					externalMenu,
					autoAddRules,
				})
			);

			setIsReady(true); // всё загружено
		} catch (err) {
			console.error("Ошибка инициализации данных:", err);
		}
	}

	useEffect(() => {
		getData();
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	if (!isReady) {
		return (
			<>
				<div style={{
					height: '100vh',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center'
				}}>
					<Skeleton height={100} width={300} borderRadius={12} />
				</div>

				<div style={{
					'position': 'absolute',
					'top': '50%',
					'left': '50%',
					'transform': 'translate(-50%, -50%)',
					'zIndex': 1,
					'background': '#fff',
					'padding': '20px',
					'borderRadius': '12px',
					'boxShadow': '0 2px 8px rgba(0,0,0,0.15)',
				}}>
					Загрузка данных колл-центра...
				</div>
			</>
		);
	}

	if (isReady) {
		return (
			<div>
				<Outlet />
			</div>
		);
	}
}

export default Layout